export default "__VITE_ASSET__Boo6FNFl__"